/**
 * Box Shadow enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BOX_SHADOW {
	NONE = "none",
	THEME = "theme",
	XSMALL = "x-small",
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large",
	XLARGE = "x-large"
}

export type BOX_SHADOW_string = keyof typeof BOX_SHADOW;

export const BOX_SHADOW_default: BOX_SHADOW_string = "NONE";
